// extracted by mini-css-extract-plugin
export default {"apps-suggestions-title":"_5wgy6l","appsSuggestionsTitle":"_5wgy6l","title-text":"_qusmcw","titleText":"_qusmcw"};